var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMilestone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2,28.4v-4.4c5.1-0.9,9-5.4,9-10.8c0-6.1-4.9-11-11-11c-6.1,0-11,4.9-11,11c0,5.4,3.9,9.9,9,10.8v4.4 c-5.1,0.9-9,5.4-9,10.8c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C24.2,33.8,20.3,29.4,15.2,28.4z M6.2,13.2c0-3.9,3.1-7,7-7 c3.9,0,7,3.1,7,7s-3.1,7-7,7C9.3,20.2,6.2,17.2,6.2,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,9.2h17.9c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2H30.3c-1.1,0-2-0.9-2-2v-4C28.3,10.1,29.2,9.2,30.3,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,35.2h17.9c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2H30.3c-1.1,0-2-0.9-2-2v-4 C28.3,36.2,29.2,35.2,30.3,35.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMilestone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/milestone.2d74c885634ed9f76bf9a7682e4677ec.svg";